import React from 'react';

const Urgent = ({ fill }: { fill: string }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3857_721"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="10"
      height="10"
    >
      <rect width="10" height="10" fill={fill} />
    </mask>
    <g mask="url(#mask0_3857_721)">
      <path
        d="M5 3.52091V5.18758M5 8.75C2.92893 8.75 1.25 7.07107 1.25 5C1.25 2.92893 2.92893 1.25 5 1.25C7.07107 1.25 8.75 2.92893 8.75 5C8.75 7.07107 7.07107 8.75 5 8.75ZM5.02075 6.43758V6.47925L4.97925 6.47909V6.43758H5.02075Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Urgent;
